import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd';
import { HttpErrorResponse } from '@angular/common/http';

import { GlobalComponent, Result, UserData } from '../../environments/global';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss']
})
export class CheckComponent implements OnInit {
  // TABLE VARS
  public dataSet = [];
  // COMPONENT VARS
  public isLoading: boolean = true;

  // ################################################
  // CLASS: CONSTRUCTOR
  constructor(
    private router: Router,
    public g: GlobalComponent,
    private message: NzMessageService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    const query: string = 'SELECT * from chk_times INNER JOIN chk_orders' +
      ' ON chk_times.orderId = chk_orders.id' +
      ' WHERE `userId`=' + this.g.userData.id + ' ORDER BY DATE DESC LIMIT 20';
    this.g.mysql(query)
      .subscribe((res: Result) => {
        this.isLoading = false;
        console.log(res.data);
        this.dataSet = res.data;
      }, (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
      });
  }
  goOrders() {
    this.router.navigateByUrl('/track/(trackContent:ordine)');
  }
}
